module.exports = __webpack_public_path__ + "img/img_pocket_note.45d177a3.png";